<!-- 年应收 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <div style="position: absolute;right: 0;z-index: 9;">
        <a-radio-group default-value="0" @change="onChange2" size="small">
          <a-radio-button value="0">
            {{ $t('本年') }}
          </a-radio-button>
          <a-radio-button value="1">
            {{ $t('去年') }}
          </a-radio-button>
        </a-radio-group>
      </div>
      <div style="position: absolute;right: 0;top: 70px;">{{yearsTotal}}</div>
      <div ref="option" id="chart" style="height: 100%;width: 100%;"></div>
      <!-- <Echart ref="option" :options="option" style="height: 100%"></Echart> -->
    </div>
  </div>
</template>
<script>
  // import echarts from 'echarts/lib/echarts';
  import echarts from 'echarts'
  import {
    putAction
  } from '@/api/manage'
  export default {
    props: {
      titleImage: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        title: this.$t('年应收'),
        url: {
          doQueryChargeMoneyByPriceCode: "/jeecg-charge/meter/waterAnalysis/doQueryChargeMoneyByPriceCode"
        },
        option: {},
        yearsTotal: ''
      }
    },
    mounted() {},
    methods: {
      onChange2(e){
        this.option = {};
        this.getData(e.target.value);
      },
      init() {
        // this.$refs.option.showLoading('default',{
        //     maskColor: 'rgba(0,0,0,0.3)',
        //     color: '#6ED9F2',
        //     text: ''
        // })
        this.getData(0)
      },
      getData(e){
        putAction(this.url.doQueryChargeMoneyByPriceCode,{doQueryChargeMoneyByPriceCode:e}).then(res=>{
          if(res.success){
            var data = res.result;
            if(e == 0){
              this.yearsTotal = this.$t('本年应收：{a}元  本年实收：{b}元', { a: data.shouldChargedTotal, b: data.actuallyChargedTotal });
            }else{
              this.yearsTotal = this.$t('去年应收：{a}元  去年实收：{b}元', { a: data.shouldChargedTotal, b: data.actuallyChargedTotal });
            }
            this.setOption(data.meterIndexPriceChargeVoList);
          }
        })
      },
      setOption(list) {
          var chartDom = document.getElementById('chart');
          var myChart = echarts.init(chartDom);
          var xData = [];
          var yData1 = [];
          var yData2 = [];
          list.map(item=>{
            xData.push(item.meterUserPriceName);
            yData1.push(item.shouldCharged?item.shouldCharged:0);
            yData2.push(item.actuallyCharged?item.actuallyCharged:0);
          })
          let seriesData = []
          seriesData.push({
            name: this.$t('应收'),
            type: 'pictorialBar',
            barMaxWidth: 22,
            stack: 'sum',
            smooth: true,
            symbol: 'triangle',
            animationDelay: 0,
            animationDuration: 300,
            data: yData1,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                      offset: 0,
                      color: 'rgba(80,227,194,0.5)',
                  },
                  {
                      offset: 1,
                      color: 'rgba(80,227,194,0.1)',
                  },
                ],
                global: false,
              },
            },
            z: 10
          });
          seriesData.push({
            name: this.$t('实收'),
            type: 'pictorialBar',
            barMaxWidth: 22,
            barGap: "-40%",
            stack: 'total',
            smooth: true,
            symbol: "triangle",
            animationDelay: 100,
            animationDuration: 300,
            data: yData2,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                      offset: 0,
                      color: 'rgba(70,52,250,0.5)',
                  },
                  {
                      offset: 1,
                      color: 'rgba(70,52,250,0.1)',
                  },
                ],
                global: false,
              },
            },
            z: 100
          });
          // this.$refs.option.hideLoading()
          this.option = {
              color: ['#50E3C2','#4634FA','#32C5FF','#F6BB2F','#0091FF','#0394FF','#0C2D82','#B620E0','#F7B500','#FA6400','#E02020'],
              title: {
                  show: false
              },
              tooltip: {
                  trigger: 'axis',
                  backgroundColor: 'rgba(0,11,42,0.9)',
                  borderColor: '#5D6A94',
                  borderWidth: 1,
                  borderRadius: 8,
                  textStyle: {
                      color: '#CEE2FF',
                  },
                  axisPointer: {
                      type: 'line',
                      lineStyle: {
                          color: '#019AF3'
                      }
                  },
                  // formatter: '{a0}: {c0}<br/>{a1}: {c1}'
              },
              legend: {
                  type: 'scroll',
                  data: [this.$t('应收'), this.$t('实收')],
                  textStyle: {
                      color: '#CEE2FF'
                  },
                  // icon: 'circle',
                  itemHeight: 10,
                  left: 'left',
                  pageIconColor: '#aaa',
                  pageIconInactiveColor: '#2f4554',
                  pageTextStyle: {
                      color: 'rgb(91, 135, 195)'
                  }
              },
              grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
              },
              xAxis: {
                  type: 'category',
                  boundaryGap: [0, 0.01],
                  data: xData,
                  splitLine: {
                      show: false
                  },
                  axisTick:{
                      show: false
                  },
                  axisLine: {
                      show: true,
                      lineStyle: {
                          color: ['#074671'],
                      }
                  },
                  axisLabel: {
                      color: '#D1F3FF',
                      fontSize: 10
                  }
              },
              yAxis: {
                  type: 'value',
                  name: this.$t('收费(元)'),
                  nameTextStyle: {
                    color: '#D1F3FF',
                    align: 'center',
                  },
                  splitLine: {
                      show: true,
                      lineStyle: {
                          type: 'dotted',
                          color: ['#074671'],
                      }
                  },
                  axisTick:{
                      show: false
                  },
                  axisLine: {
                      show: false
                  },
                  axisLabel: {
                      color: '#D1F3FF',
                      fontSize: 10
                  }
              },
              series: seriesData
          };
          this.option && myChart.setOption(this.option);
          // 为窗口加上宽度变化事件，当宽高发生改变时，调用echarts的resize()方法，调整图表尺寸
          window.addEventListener('resize', function () {
            myChart.resize();
          })

      },
      // setOption() {
      //   var chartDom = document.getElementById('chart');
      //   var myChart = echarts.init(chartDom);
      //   var option = {
      //     textStyle: {
      //       color: '#fff'
      //     },
      //     grid: {
      //       bottom: '10%'
      //     },
      //     tooltip: {
      //         trigger: 'axis',
      //         formatter: '{b}<br />{a0}: {c0}',
      //         backgroundColor: 'rgba(0,11,42,0.9)',
      //         borderColor: '#5D6A94',
      //         borderWidth: 1,
      //         borderRadius: 8,
      //         textStyle: {
      //             color: '#CEE2FF',
      //         },
      //         axisPointer: {
      //             type: 'line',
      //             lineStyle: {
      //                 color: '#019AF3'
      //             }
      //         }
      //     },
      //     legend: {
      //       show: true,
      //       top: '3%',
      //       left: '3%',
      //       textStyle: {
      //         color: '#fff'
      //       },
      //     },
      //     xAxis: [{
      //       type: 'category',
      //       data: ['区域1','区域2','区域3','区域4','区域5','区域6','区域7'],
      //       axisPointer: {
      //         type: 'shadow'
      //       },
      //     }],
      //     yAxis: [{
      //         type: 'value',
      //         axisLabel: {
      //           textStyle: {
      //               color: '#D1F3FF',
      //               fontStyle: 'normal',
      //               fontFamily: '微软雅黑',
      //               fontSize: 12,
      //           },
      //           formatter: '{value}'
      //         },
      //         splitLine: {
      //             show: true,
      //             lineStyle: {
      //                 type: 'dotted',
      //                 color: ['#074671'],
      //             }
      //         }
      //       },
      //     ],
      //     series: [
      //       {
      //         name: '应收',
      //         type: 'bar',
      //         barWidth: 10,
      //         tooltip: {
      //           formatter: function(value) {
      //             return value;
      //           }
      //         },
      //         data: [20,33,44,45,46,78,88],
      //         itemStyle: {
      //           normal: {
      //             color: '#3BA1FF',
      //             // barBorderRadius: [5, 5, 0, 0],
      //           }

      //         }
      //       },
      //       {
      //         name: '实收',
      //         type: 'bar',
      //         barWidth: 10,
      //         tooltip: {
      //           formatter: function(value) {
      //             return value;
      //           }
      //         },
      //         data: [20,33,33,23,34,78,45],
      //         itemStyle: {
      //           normal: {
      //             color: '#50E3C2',
      //             // barBorderRadius: [5, 5, 0, 0],
      //           }
            
      //         }
      //       },
      //     ]
      //   }
      //   option && myChart.setOption(option);
      // }
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}
  .ant-radio-button-wrapper{
    color: #fff;
    background: transparent;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
    color: #1890FF;
  }
</style>